(ns frontend.view.nev.zap-vault.tab-analytics
  (:require [common.localization :as loc]
            [frontend.view.nev.zap-vault.sub :as sub]
            [frontend.view.nev.zap-vault.event :as event]
            [re-frame.core :as rf]
            [ui.components.button.view :as button]
            [ui.components.text.view :as text]
            [ui.view.card.shared-components.entity-table :as entity-table]))

(defn view
  []
  (let [activities @(rf/subscribe [::sub/activities-table-data])
        activity-columns @(rf/subscribe [::sub/activity-table-columns])]
    [:div
     {:class "flex flex-col gap-0 border border-solid border-base-light-border-paler"}
     [:div
      {:class "flex flex-row p-4 items-center"}
      [:div
       {:class "flex flex-col gap-1"}
       [text/h2
        (loc/tr :zap-vault-analytics)]
       [text/info-text
        (loc/tr :zap-vault-analytics-info)]]
      [:div
       {:class "flex-1 flex gap-2 justify-end"}
       [button/sm-secondary-hollow
        {:tooltip (loc/tr :export-as-excel)
         :on-click (fn [_]
                     (rf/dispatch [::event/export-activities-as-excel]))}
        [:i.fal.fa-file-excel]]]]
     [:div
      {:class "flex flex-col gap-2 px-4 bg-complement-light"}
      [entity-table/view
       {:config          {:columns         activity-columns
                          :sort-model      [{:field     :common/created-on
                                             :direction :desc}]
                          :entity-type     :entity.type/vault-usage
                          :preview-button? false}
        :data            activities
        :selected-row-id nil
        :on-row-clicked  (fn [{:keys [_entity-id]}])}]]]))
